export const yesNoOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
]

export const yesNoOptionsNum = [
    { label: 'Yes', value: 1 },
    { label: 'No', value: 0 },
]

export const yesNoOptionsString = [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' },
]

export const filterOptions = [
    { label: 'All', value: '' },
    // { label: 'Failed', value: 'F' },
    { label: 'Processed', value: 'Y' },
    { label: 'Not Processed', value: 'N' },
]

export const siteOptions = [
    { label: 'VIC', value: 'VIC' },
    { label: 'NSW', value: 'NSW' },
    { label: 'SA', value: 'SA' },
    { label: 'QLD', value: 'QLD' },
]

export const orderTypeOptions = [
    { label: 'B2B', value: 'B2B' },
    { label: 'B2C', value: 'B2C' },
    { label: 'OTH', value: 'OTH' },
]

export const priorityOptions = [
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
]

export const stateOptions = [
    { label: 'VIC', value: 'VIC' },
    { label: 'QLD', value: 'QLD' },
    { label: 'NSW', value: 'NSW' },
    { label: 'WA', value: 'WA' },
    { label: 'SA', value: 'SA' },
    { label: 'NT', value: 'NT' },
    { label: 'TAS', value: 'TAS' },
    { label: 'ACT', value: 'ACT' },
]

export const carrierOptions = [
    { label: 'Australia Post', value: 'Australia Post' },
    { label: 'Startrack', value: 'Startrack' },
    { label: 'Border Express', value: 'Border Express' },
]

export const carrierServiceOptions = [
    { label: 'Express', value: 'Express' },
    { label: 'Premium', value: 'Premium' },
    { label: 'Standard', value: 'Standard' },
]

export const asnTypeOptions = [
    { label: '20 Container', value: '20 Container' },
    { label: 'Loose Container Load', value: 'Loose Container Load' },
    { label: '40 Container', value: '40 Container' },
]

export const supplierOptions = [
    { label: 'Supplier 1', value: 'Supplier 1' },
    { label: 'Supplier 2', value: 'Supplier 2' },
    { label: 'Supplier 3', value: 'Supplier 3' },
]

export const packOptions = [
    { label: 'FEFO', value: 'FEFO' },
    { label: 'FIFO', value: 'FIFO' },
    { label: 'LIFO', value: 'LIFO' },
]

export const mfaTypeOptions = [
    { label: 'Email', value: 'email' },
    { label: 'Google Authenticator', value: 'google_authenticator' },
]

export const lengthOption = [
    {
        id: 10,
        label: 10,
    },
    {
        id: 25,
        label: 25,
    },
    {
        id: 50,
        label: 50,
    },
    {
        id: 100,
        label: 100,
    },
]

export const serviceTypeOptions = [
    { label: 'REPAIR', value: 'REPAIR' },
    { label: 'MAINTENANCE', value: 'MAINTENANCE' },
    { label: 'INSPECTION', value: 'INSPECTION' },
    { label: 'OTHER', value: 'OTHER' },
]

export const scheduleOptions = [
    { label: 'Weekly', value: 'Weekly' },
    { label: 'Monthly', value: 'Monthly' },
    { label: 'Quarterly', value: 'Quarterly' },
    { label: 'Half-Yearly', value: 'Half-Yearly' },
    { label: 'Yearly', value: 'Yearly' },
]

export const eventTypeOptions = [
    { label: 'Online', value: 'Online' },
    { label: 'Offline', value: 'Offline' },
]

export const eventStatusOptions = [
    { label: 'Open', value: 'Open' },
    { label: 'Closed', value: 'Closed' },
]

export const recommendationTypeOptions = [
    { label: 'Schedule Maintenance', value: 'Schedule Maintenance' },
    { label: 'Usage Tips', value: 'Usage Tips' },
    { label: 'Part Replacement', value: 'Part Replacement' },
    { label: 'Warranty Extension', value: 'Warranty Extension' },
]

export const reminderTypeOptions = [
    { label: 'General Service', value: 'General Service' },
    { label: 'Specific Maintenance', value: 'Specific Maintenance' },
    { label: 'Part Replacement', value: 'Part Replacement' },
    { label: 'Warranty Ended', value: 'Warranty Ended' },
    { label: 'Other', value: 'Other' },
]

export const faqTypeOptions = [
    { label: 'Product Advice', value: 'PRODUCT_ADVICE' },
    { label: 'Product Information', value: 'PRODUCT_INFORMATION' },
    { label: 'Product Care', value: 'PRODUCT_CARE' },
    { label: 'FAQ', value: 'FAQ' },
]

export const ProductFromOptions = [
    { label: 'By Individual', value: 'individual' },
    { label: 'By Business', value: 'business' },
    { label: 'By Admin', value: 'admin' },
    { label: 'By User', value: 'user' },
    { label: 'By Invite', value: 'invite' },
    { label: 'Other', value: 'other' },
]

export const ComponentFilterOptions = [
    { label: 'Product', value: false },
    { label: 'Component', value: true },
]

export const CompanyTypeOptions = [
    { label: 'All', value: 'all' },
    { label: 'Register', value: 'permanent' },
    { label: 'Not Register', value: 'temporary' },
]

export const IntegrationOptions = [
    { label: 'Meson', value: 'meson' },
    // { label: 'Data Boat', value: 'data-boat' },
    // { label: 'Next3PL', value: 'next3pl' },
    // { label: 'NetSuite', value: 'netsuite' },
]

export const IntegrationCategoryOptions = [
    { label: 'WMS', value: 'wms' },
    { label: 'ERP', value: 'erp' },
    { label: 'E-Commerce', value: 'ecommerce' },
    { label: 'Marketplace', value: 'marketplace' },
    { label: 'Shipping', value: 'shipping' },
    { label: 'Payment', value: 'payment' },
    { label: 'Other', value: 'other' },
]

export const IntegrationIDOptions = [
    { label: 'ASN', value: 'asn' },
    { label: 'PO', value: 'po' },
]

export const ShopifyScopesOptions = [
    { label: 'Write assigned fulfillment orders', value: 'write_assigned_fulfillment_orders' },
    { label: 'read assigned fulfillment orders', value: 'read_assigned_fulfillment_orders' },
    { label: 'read ulfillments', value: 'read_fulfillments' },
    { label: 'write fulfillments', value: 'write_fulfillments' },
    { label: 'write inventory', value: 'write_inventory' },
    { label: 'read inventory', value: 'read_inventory' },
    { label: 'write locations', value: 'write_locations' },
    { label: 'read locations', value: 'read_locations' },
    { label: 'write orders', value: 'write_orders' },
    { label: 'read orders', value: 'read_orders' },
    { label: 'read products', value: 'read_products' },
    { label: 'write shipping', value: 'write_shipping' },
    { label: 'read shipping', value: 'read_shipping' },
    { label: 'read customers', value: 'read_customers' },
    // { label: 'read orders', value: 'read_orders' },
    // { label: 'read products', value: 'read_products' },
    { label: 'write products', value: 'write_products' },
    { label: 'write merchant managed fulfillment orders', value: 'write_merchant_managed_fulfillment_orders' },
    { label: 'read merchant managed fulfillment orders', value: 'read_merchant_managed_fulfillment_orders' },
    { label: 'write third party fulfillment orders', value: 'write_third_party_fulfillment_orders' },
    { label: 'read third party fulfillment orders', value: 'read_third_party_fulfillment_orders' },
]

export const InventoryUpdateMethodOptions = [
    { label: 'API', value: 'api' },
    { label: 'Excel', value: 'excel' },
    { label: 'None', value: 'none' },
]

export const connectorsOptions = [
    { label: 'MESON', value: 'MESON' },
    { label: 'DATABOT', value: 'DATABOT' },
    { label: 'NEXT3PL', value: 'NEXT3PL' },
    { label: 'NETSUITE', value: 'NETSUITE' },
    { label: 'SHOPIFY', value: 'SHOPIFY' },
    { label: 'WOOCOMMERCE', value: 'WOOCOMMERCE' },
]

export const gridOptions = [
    { label: '1', value: 'col-span-1' },
    { label: '2', value: 'col-span-2' },
    { label: '3', value: 'col-span-3' },
    { label: '4', value: 'col-span-4' },
    { label: '5', value: 'col-span-5' },
    { label: '6', value: 'col-span-6' },
    { label: '7', value: 'col-span-7' },
    { label: '8', value: 'col-span-8' },
    { label: '9', value: 'col-span-9' },
    { label: '10', value: 'col-span-10' },
    { label: '11', value: 'col-span-11' },
    { label: '12', value: 'col-span-12' },
]

export const moduleList = [
    { key: 'group', name: 'roles', title: 'user-roles' },
    { key: 'maestro company', name: 'company', title: 'company-setup' },
    { key: 'shopify stg order dtl', name: 'order-detail', title: 'order-detail' },
    { key: 'shopify stg order hdr', name: 'sales-orders', title: 'sales-orders' },
    { key: 'maestro user', name: 'users', title: 'user-setup' },
    { key: 'Integration', name: 'integration', title: 'integration' },
    { key: 'Integration Type', name: 'integration-type', title: 'integration-type' },
    { key: 'SFTP Configuration', name: 'sftp-configuration', title: 'sftp-configuration' },
    { key: 'maestro api access key', name: 'access-key', title: 'access-key' },
    { key: 'API Endpoint', name: 'api-configuration', title: 'api-configuration' },
    { key: 'ASN Header', name: 'inbound-delivery', title: 'inbound-delivery' },
    { key: 'Ensemble Customer', name: 'customers', title: 'customer-setup' },
    { key: 'maestro ensemble sku', name: 'products', title: 'products' },
    { key: 'machship company', name: 'machship', title: 'machship-consignments' },
    { key: 'machship configuration', name: 'machship-integration', title: 'machship-setup' },
    { key: 'meson stg asn hdr', name: 'asn', title: 'meson-asn' },
    { key: 'meson stg purchase order hdr', name: 'stock-holdings', title: 'meson-stock-holdings' },
    { key: 'meson stg shipment hdr', name: 'shipments', title: 'meson-shipments' },
    { key: 'shopify store', name: 'shopify-integration', title: 'shopify-integration' },
    { key: 'woo commerce store', name: 'woocommerce-integration', title: 'woocommerce-integration' },
    { key: 'xero configuration', name: 'xero-integration', title: 'xero-setup' },
    { key: 'xero invoice', name: 'xero', title: 'xero-invoicing' },
    { key: 'maestro ensemble order type', name: 'order-type', title: 'order-type' },
    { key: 'maestro ensemble warehouse', name: 'warehouse', title: 'warehouse' },
    { key: 'Ensemble Transaction Log', name: 'transaction-log', title: 'transaction-log' },
    { key: 'report', name: 'reports', title: 'reports' },
    { key: 'financials reports', name: 'financials', title: 'reports-financials' },
    { key: 'inbound reports', name: 'inbound', title: 'reports-inbound' },
    { key: 'inventory reports', name: 'inventory', title: 'reports-inventory' },
    { key: 'outbound reports', name: 'outbound', title: 'reports-outbound' },
    { key: 'performance reports', name: 'performance', title: 'reports-performance' },
    { key: 'financials dashboards', name: 'financials-dashboard', title: 'dashboards-financials' },
    { key: 'inbound dashboards', name: 'inbound-dashboard', title: 'dashboards-inbound' },
    { key: 'inventory dashboards', name: 'inventory-dashboard', title: 'dashboards-inventory' },
    { key: 'outbound dashboards', name: 'outbound-dashboard', title: 'dashboards-outbound' },
    { key: 'performance dashboards', name: 'performance-dashboard', title: 'dashboards-performance' },
    { key: 'SFTP file listings', name: 'file-directory', title: 'file-directory' },
    { key: 'Celery job monitoring', name: 'cron-jobs', title: 'cron-jobs' },
]
